<form>
    <!-- Modal Header -->
    <div class="modal-header">
        <h4 class="modal-title">Manage Approved Bank in Accounts </h4>
        <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="reset()"></button>
    </div>

    <div class="modal-body">
        <div class="container-fluid p-0">
            <div class="d-flex justify-content-end my-1">
                <button class="btn btn-secondary" (click)="openAddBankAccountModal()"><i class="fas fa-plus"></i> Add
                    Account</button>
            </div>
            <h3>Ready to use accounts</h3>
            <table class="table">
                <thead>
                    <tr>
                        <th>Type</th>
                        <th>Account Details</th>
                        <th>Action</th>
                    </tr>
                </thead>

                @if(approvedAccountList.length>0){
                @for (acc of approvedAccountList; track $index) {
                <tbody>
                    <tr>
                        <td>
                            @if(acc.ContactId==undefined){<span>Owner</span> } @else{<span>Guarantor</span>}
                        </td>
                        <td>{{acc.HolderName}} ({{acc.Bank}} - {{acc.AccountNumber}})</td>
                        <td><button class="btn btn-info" type="button" (click)="addCustomerAccountToParent(acc)">Use
                                This</button></td>
                    </tr>
                </tbody>

                }

                }
            </table>

        </div>
    </div>

</form>